// import icon1 from "../../images/welcome/welcomeCards/welcomeCardicon1.svg";
// import icon2 from "../../images/welcome/welcomeCards/welcomeCardicon2.svg";
// import icon3 from "../../images/welcome/welcomeCards/welcomeCardicon3.svg";
// import icon4 from "../../images/welcome/welcomeCards//welcomeCardicon4.svg";
import icon1 from "../../images/welcome/welcomeCards/icon1.svg";
import bottom1 from "../../images/welcome/welcomeCards/bottom1.svg";
import icon2 from "../../images/welcome/welcomeCards/icon2.svg";
import bottom2 from "../../images/welcome/welcomeCards/bottom2.svg";
import icon3 from "../../images/welcome/welcomeCards/icon3.svg";
import bottom3 from "../../images/welcome/welcomeCards/bottom3.svg";
import icon4 from "../../images/welcome/welcomeCards/icon4.svg";
import bottom4 from "../../images/welcome/welcomeCards/bottom4.svg";
import icon5 from "../../images/welcome/welcomeCards/icon5.svg";
import bottom5 from "../../images/welcome/welcomeCards/bottom5.svg";
import icon6 from "../../images/welcome/welcomeCards/icon6.svg";
import bottom6 from "../../images/welcome/welcomeCards/bottom6.svg";

export const welcomeCardsData = [
  {
    icon: icon1,
    title: "Empower your business with SkaleBot",
    bottom: bottom1,
    hoverText:"Empowering diverse businesses to maximize growth through WhatsApp."
  },
  {
    icon: icon2,
    title: "Build a robust customer base & Generate new Leads",
    bottom: bottom2,
    hoverText:"Elevate customer loyalty and retention through personalized engagement."

  },
  {
    icon: icon3,
    title: "Integrate the Catalogue feature seamlessly.",
    bottom: bottom3,
    hoverText:"Seamless creation and sharing of personalized product catalogs, boosting sales performance."

  },
  {
    icon: icon4,
    title: "Unleash impactful Campaigns",
    bottom: bottom4,
    hoverText:"Create targeted campaigns for engagement and conversions. Track results, optimize strategies."

  },
  {
    icon: icon5,
    title: "Sales Agent & Order Management system",
    bottom: bottom5,
    hoverText:"Connect customers to sales agents for efficient support & Streamline order management for enhanced performance."


  },
  {
    icon: icon6,
    title: "Dashboard with Actionable insights",
    bottom: bottom6,
    hoverText:"Intelligent insights for smart business decisions and optimized performance."

  },
];
